import React, { useEffect, useState } from "react";
import { Box, Typography, Stack, FormControlLabel, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { AccountLevelArkchatPermission, ApprovalStatus, MessageType, TaskStatus } from "../../../utils/constant";
import PopupModal from "../../../common/PopupModal";
import UpdateTaskSwitch from "../../../common/UpdateTaskSwitch";
import DrawerInput from "./DrawerInput";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import StartTask from "./StartTask";
import moment from "moment";
import useAppSelectors from "../../../customHooks/useAppSelectors";
import { useDispatch } from "react-redux";
import { colorSchemes, crossIcon, crossIconDiv, fontSizeSchemes } from "../../../assets/commonFunction";
import { handleCheckShouldMainTaskComplete, requestGetGroupRecipient, requestgroupMemberDetails } from "../../../appStore/actions/ArkchatGroup/action";
import CustomPopup from "../../../components/CustomPopup";
import session, { handleSelected, taskUpdateMenuList } from "../../../utils/helper";
const classes = {
  drawerBody: {
    minWidth: "31.25rem",
    maxWidth: "31.25rem",
    height: "100%",
  },
  header: {
    backgroundColor: "#F9F8F8",
    color: "#0000",
    padding: "7px 8px",
  },
  iconDiv: crossIconDiv,
  iconn: crossIcon,
  radiogp: {
    display: "block",
  },
  leaveCompleteTaskFooter: {
    padding: "1.5rem 0rem 3rem 0rem",
    display: "flex",
    alignItems: "center",
    borderTop: `1px solid ${colorSchemes.borderColor}`,
    gap: "0.5rem",
  },
  leaveCompleteTaskFooterButton: {
    width: "9rem",
    height: "2.5rem",
    borderRadius: "0.25rem",
    fontSize: fontSizeSchemes.font14,
    fontWeight: 500,
    backgroundColor: colorSchemes.white,
    color: colorSchemes.black,
    textTransform: "none",
    border: `1px solid ${colorSchemes.crossIconBorder}`,
    "&:hover": {
      backgroundColor: colorSchemes.white,
      color: colorSchemes.black,
      border: `1px solid ${colorSchemes.crossIconBorder}`,
    },
  },
};

const selectApprovalValue = [
  { title: `Cancel or close approval request`, value: `cancelApproval` },
  { title: `Change approval date | Time | Priority `, value: `changeValues` },
  {
    title: `Request approval from someone else`,
    value: `reassignTask`,
  },
  { title: `Change approval request to task`, value: `changeType` },
];

const TaskUpdate = ({
  setTaskUpdateOpen,
  setSelectRecipientsDrawerOpen,
  setStepper,
  taskData,
  setTaskData,
  setMessageType,
  msgType,
  handleClickYouTube,
  setFileAttachment,
  handleClickGoogle,
  handleClickCloudStorage,
  fileAttachment,
  attachment,
  setAttachment,
  handleUpdateTaskApproval,
  updateTaskApprovalMsg,
  setUpdateTaskApprovalMsg,
  checkedType,
  setCheckedType,
  setReplyParentMsg,
  selectedRecipients,
  setDueDate,
  setDueTime,
  leaveCompleteTask,
  setLeaveCompleteTask,
  setTaskModalDeatils,
  setIsTaskUpdateTypeModalOpen,
  isTaskUpdateTypeModalOpen,
  handleclickAttherate,
  setIsTaskTypeModalOpen,
  taskModalDeatils,
  setSelectedRecipients
}) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const [isChangeMsgTypeOpen, setChangeTypeOpen] = useState(false);
  // const [showAlert, setShowAlert] = useState(false);
  const [actualTimeValue, setActualTimeValue] = useState("");
  const [startTaskOpen, setStartTaskOpen] = useState(false);
  const [selectedTaskData, setSelectedTaskData] = useState({});
  const [shouldAllowMainTaskComplete, setShouldAllowMainTaskComplete] = useState(true);
  const [taskAlertPopup, setTaskAlertPopup] = useState(false);
  const { currentUserData, groupmemberdetails, groupRecipientDetails, selectedGroup } = useAppSelectors();
  const isThreadScreen = session.get("isThreadScreen");

  const dispatch = useDispatch();

  const handleMenuAction = (event) => {
    if (event?.target?.checked) {
      if (event?.target?.name === "reassignTask") {
        const reqbody = {
          group_id: taskData?.group_id,
          target_subscriber_id:
            currentUserData?.activeSubscriber?.id ?? selectedGroup?.subscriberId,
        };

        dispatch(requestgroupMemberDetails(reqbody));
        dispatch(requestGetGroupRecipient(taskData?.group_id));
        setSelectRecipientsDrawerOpen(true);
        setCheckedType(event?.target?.name);
        if(!isThreadScreen){
          handleSelected({groupmemberdetails,groupRecipientDetails,taskData, setSelectedRecipients, appContent, selectedRecipients});
        }
        if (taskData?.type === MessageType.Task) {
          let taskObject = {
            title: appContent?.KEY373,
            type: MessageType?.Task,
            subHeader: appContent?.KEY250,
            buttonname: appContent?.KEY374,
            title2: appContent?.KEY375,
            msgType: MessageType?.Task,
          };
          setTaskModalDeatils(taskObject);
        } else {
          let taskObject = {
            title: appContent?.KEY296,
            type: MessageType?.Approval,
            subHeader: appContent?.KEY299,
            buttonname: appContent?.KEY300,
            title2: appContent?.KEY296,
            msgType: MessageType?.Approval,
          };
          setTaskModalDeatils(taskObject);
        }
      } else if (event?.target?.name === "reopen") {
        const updatedTaskBody = {
          ...taskData,
          task_status: TaskStatus?.Pending,
        };
        setCheckedType(event?.target?.name);
        setTaskData(updatedTaskBody);
      } else if (event?.target?.name === "changeValues") {
        setCheckedType(event?.target?.name);
        setSelectRecipientsDrawerOpen(true);
        setStepper("datetime");
      } else if (event?.target?.name === "cancelTask") {
        const updatedTaskBody = {
          ...taskData,
          task_status: TaskStatus?.Cancelled,
        };
        setCheckedType(event?.target?.name);
        setTaskData(updatedTaskBody);
      } else if (event?.target?.name === "cancelApproval") {
        const updatedTaskBody = {
          ...taskData,
          approval_status: ApprovalStatus?.Cancelled,
        };
        setCheckedType(event?.target?.name);
        setTaskData(updatedTaskBody);
      } else if (event?.target?.name === "changeType") {
        setMessageType(taskData?.type);
        setCheckedType(event?.target?.name);
        setChangeTypeOpen(true);
      } else if (event?.target?.name === "done") {
        if(!shouldAllowMainTaskComplete){
          setTaskAlertPopup(true);
          return;
        }
        const updatedTaskBody = {
          ...taskData,
          task_status: TaskStatus?.Done,
        };
        setStartTaskOpen(true);
        setTaskData(updatedTaskBody);
      } else if (event?.target?.name === "accept") {
        const updatedTaskBody = {
          ...taskData,
          approval_status: ApprovalStatus?.Approved,
          nhi_nhi: false,
        };
        setCheckedType(event?.target?.name);
        setTaskData(updatedTaskBody);
      } else if (event?.target?.name === "reject") {
        const updatedTaskBody = {
          ...taskData,
          approval_status: ApprovalStatus?.Rejected,
          nhi_nhi: false,
        };
        setCheckedType(event?.target?.name);
        setTaskData(updatedTaskBody);
      } else if (event?.target?.name === "approveAndAskApproval") {
        const updatedTaskBody = {
          ...taskData,
          approval_status: ApprovalStatus?.Approved,
          nhi_nhi: true,
        };
        setCheckedType(event?.target?.name);
        setTaskData(updatedTaskBody);
        const reqbody = {
          group_id: taskData?.group_id,
          target_subscriber_id:
            currentUserData?.activeSubscriber?.id ?? selectedGroup?.subscriberId,
        };
        dispatch(requestgroupMemberDetails(reqbody));
        dispatch(requestGetGroupRecipient(taskData?.group_id));

        setSelectRecipientsDrawerOpen(true);
        let taskObject = {
          title: appContent?.KEY296,
          type: MessageType?.Approval,
          subHeader: appContent?.KEY299,
          buttonname: appContent?.KEY300,
          title2: appContent?.KEY296,
          msgType: MessageType?.ApproveAndAskApproval,
        };
        setTaskModalDeatils(taskObject);
        setIsTaskTypeModalOpen(false);
        handleclickAttherate(MessageType?.Approval);
        setStepper("user");
        setCheckedType(event?.target?.name);
        if(!isThreadScreen){
          handleSelected({groupmemberdetails,groupRecipientDetails,taskData, setSelectedRecipients, appContent, selectedRecipients});
        }
      } else if (event?.target?.name === "rejectAndAskApproval") {
        const updatedTaskBody = {
          ...taskData,
          approval_status: ApprovalStatus?.Rejected,
          nhi_nhi: true,
        };
        setCheckedType(event?.target?.name);
        setTaskData(updatedTaskBody);
        const reqbody = {
          group_id: taskData?.group_id,
          target_subscriber_id:
            currentUserData?.activeSubscriber?.id ?? selectedGroup?.subscriberId,
        };
        dispatch(requestgroupMemberDetails(reqbody));
        dispatch(requestGetGroupRecipient(taskData?.group_id));

        setSelectRecipientsDrawerOpen(true);
        let taskObject = {
          title: appContent?.KEY296,
          type: MessageType?.Approval,
          subHeader: appContent?.KEY299,
          buttonname: appContent?.KEY300,
          title2: appContent?.KEY296,
          msgType: MessageType?.RejectAndAskApproval,
        };
        setTaskModalDeatils(taskObject);
        setIsTaskTypeModalOpen(false);
        handleclickAttherate(MessageType?.Approval);
        setStepper("user");
        setCheckedType(event?.target?.name);
        if(!isThreadScreen){
          handleSelected({groupmemberdetails,groupRecipientDetails,taskData, setSelectedRecipients, appContent, selectedRecipients});
        }
      }
    } else {
      setCheckedType("");
    }
  };

  const handleDoneMsgTypeChange = () => {
    const updatedTaskBody = {
      ...taskData,
      type:
        msgType === MessageType?.Approval
          ? MessageType?.Approval
          : MessageType?.Task,
      approval_status:
        msgType === MessageType?.Approval ? ApprovalStatus?.Pending : 0,
      task_status: msgType === MessageType?.Task ? TaskStatus?.Pending : 0,
    };
    setTaskData(updatedTaskBody);
    setChangeTypeOpen(false);
  };

  const handleCloseUpdateDrawerFinal = () => {
    setLeaveCompleteTask(false);
    setReplyParentMsg("");
    setDueDate(dayjs());
    setDueTime(dayjs().set("hour", 23).set("minute", 59).set("second", 0));
    setMessageType(MessageType?.Message);
    setStepper("user");
    setTaskUpdateOpen(false);
    setCheckedType(null);
    handleConfirmation();
    setIsTaskUpdateTypeModalOpen(false);
    setTaskData({});
  };

  const handleCloseUpdateDrawer = () => {
    // if (!checkedType) {
    //   setDueDate(dayjs());
    //   setDueTime(dayjs().set("hour", 23).set("minute", 59).set("second", 0));
    //   setMessageType(MessageType?.Message);
    //   setStepper("user");
    //   setTaskUpdateOpen(false);
    //   setCheckedType(null);
    // } else {
    //   setShowAlert(true);
    // }
    if (checkedType && !leaveCompleteTask) {
      setLeaveCompleteTask(true);
    } else {
      handleCloseUpdateDrawerFinal();
    }
  };
  const handleConfirmation = () => {
    setDueDate(dayjs());
    setDueTime(dayjs().set("hour", 23).set("minute", 59).set("second", 0));
    setMessageType(MessageType?.Message);
    setStepper("user");
    setTaskUpdateOpen(false);
    setCheckedType(null);
  };

  const handleActualTime = () => {
    //task actual time
    const updatedTaskBody = {
      ...taskData,
      actual_time: {
        timeType: taskData?.estimated_time?.timeType,
        timeValue: +actualTimeValue,
      },
      end_time: moment().unix(),
    };
    setCheckedType("done");
    setTaskData(updatedTaskBody);
    setStartTaskOpen(false);
  };

  useEffect(() => {
    setSelectedTaskData(taskData);
    if(taskData?.is_main){
      dispatch(handleCheckShouldMainTaskComplete(taskData?.id)).then((res)=>{
        setShouldAllowMainTaskComplete(res);
      })
    }
  }, []);

  const LeaveCompleteTaskBody = () => (
    <>
      <Typography fontSize={fontSizeSchemes.font14} fontWeight={400}>
        {`${appContent?.KEY330} ${
          selectedTaskData?.type === MessageType?.Approval
            ? appContent?.KEY334
            : appContent?.KEY335
        } ${" "}`}

        {appContent?.KEY331}
      </Typography>
    </>
  );
  const LeaveCompleteTaskFooter = () => (
    <Box sx={classes.leaveCompleteTaskFooter}>
      <Button
        onClick={handleCloseUpdateDrawerFinal}
        variant="contained"
        color="primary"
        sx={classes.leaveCompleteTaskFooterButton}
      >
        {appContent?.KEY332}
      </Button>
      <Button
        onClick={() => setLeaveCompleteTask(false)}
        variant="contained"
        color="primary"
        sx={classes.leaveCompleteTaskFooterButton}
      >
        {appContent?.KEY333}
      </Button>
    </Box>
  );

  const TaskCompleteMsg = () => (
    <>
      <Typography fontSize={fontSizeSchemes.font14} fontWeight={400}>
        {appContent?.KEY376}
      </Typography>
    </>
  );


  return (
    <Box sx={classes?.drawerBody}>
      <CustomPopup
        handleCloseAction={handleCloseUpdateDrawer}
        open={leaveCompleteTask}
        title={appContent?.KEY329}
        children={<LeaveCompleteTaskBody />}
        handleClose={() => setLeaveCompleteTask(false)}
        footer={<LeaveCompleteTaskFooter />}
      />
      <CustomPopup
        handleCloseAction={()=>setTaskAlertPopup(false)}
        open={taskAlertPopup}
        title={appContent?.KEY23}
        children={<TaskCompleteMsg/>}
        handleClose={() => setTaskAlertPopup(false)}
        footer={""}
      />
      {startTaskOpen && (
        <StartTask
          isActualTime={true}
          open={startTaskOpen}
          taskData={taskData}
          setStartTaskOpen={setStartTaskOpen}
          actualTimeValue={actualTimeValue}
          setActualTimeValue={setActualTimeValue}
          handleActualTime={handleActualTime}
        />
      )}

      {isChangeMsgTypeOpen && (
        <PopupModal
          title={"Change approval request to task"}
          setMessageType={setMessageType}
          msgType={msgType}
          isChangeMsgType={true}
          setPopupModalOpen={setChangeTypeOpen}
          handleDoneMsgTypeChange={handleDoneMsgTypeChange}
        />
      )}
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        sx={classes.header}
      >
        <Typography sx={classes.iconDiv}>
          <CloseIcon sx={classes.iconn} onClick={handleCloseUpdateDrawer} />
        </Typography>
        <Typography
          color={"black"}
          fontSize={fontSizeSchemes.font16}
          fontWeight={400}
        >
          {MessageType?.Task === selectedTaskData?.type
            ? appContent?.KEY320
            : appContent?.KEY341}
        </Typography>
      </Stack>
      <Box mt={"0.8rem"} padding={"0.2rem 0.4rem 0.4rem 0.4rem"}>
        <Typography
          fontWeight={600}
          maxWidth={"100%"}
          paddingLeft={"0.4rem"}
          fontSize={fontSizeSchemes.font17}
        >
          {selectedTaskData?.from?.id === currentUserData?.id
            ? appContent?.KEY323
            : selectedTaskData?.type === MessageType?.Approval
              ? appContent?.KEY340
              : appContent?.KEY322}
        </Typography>
        {/* <Typography>Write a message and click send</Typography> */}

        <Box padding={"0.4rem"}>
          {/* for Task */}
          {selectedTaskData?.type === MessageType?.Task && (
            <>
              {selectedTaskData?.assignee?.id === currentUserData?.id &&
                selectedTaskData?.task_status === TaskStatus?.Started && (
                  <Box
                    width={"100%"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    mt={"0.4rem"}
                  >
                    <Box>
                      <Typography fontSize={"0.85rem"}>
                        {selectedTaskData?.from?.id === currentUserData?.id
                          ? appContent.KEY324
                          : appContent.KEY324}
                      </Typography>
                    </Box>
                    <Box>
                      <FormControlLabel
                        control={
                          <UpdateTaskSwitch
                            name={"done"}
                            switchLabel=""
                            checked={checkedType === "done"}
                            handleChange={(event) => handleMenuAction(event)}
                          />
                        }
                      />
                    </Box>
                  </Box>
                )}
              {(selectedTaskData?.from?.id === currentUserData?.id ||
                currentUserData?.activePermission ===
                  AccountLevelArkchatPermission?.ADMIN) && (
                <>
                  {taskUpdateMenuList(currentUserData,selectedTaskData, groupRecipientDetails)?.map(
                    (item) => (
                      <Box
                        width={"100%"}
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                        mt={"0.4rem"}
                        key={item?.title}
                      >
                        <Box>
                          <Typography fontSize={"0.85rem"}>
                            {item?.title}
                          </Typography>
                        </Box>
                        <Box>
                          <FormControlLabel
                            control={
                              <UpdateTaskSwitch
                                disabled={
                                  (item?.value === "reopen" &&
                                    selectedTaskData?.task_status ===
                                      TaskStatus?.Done) ||
                                  item?.value !== "reopen"
                                    ? false
                                    : true
                                }
                                name={item?.value}
                                switchLabel=""
                                checked={checkedType === item?.value}
                                handleChange={(event) =>
                                  handleMenuAction(event)
                                }
                              />
                            }
                          />
                        </Box>
                      </Box>
                    ),
                  )}
                </>
              )}
            </>
          )}

          {/* for Approval */}
          {selectedTaskData?.type === MessageType?.Approval && (
            <>
              {selectedTaskData?.assignee?.id === currentUserData?.id && (
                <>
                  <Box
                    width={"100%"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    mt={"0.4rem"}
                  >
                    <Box>
                      <Typography fontSize={"0.85rem"}>
                        {appContent?.KEY337}
                      </Typography>
                    </Box>
                    <Box>
                      <FormControlLabel
                        control={
                          <UpdateTaskSwitch
                            name={"accept"}
                            switchLabel=""
                            checked={checkedType === "accept"}
                            handleChange={(event) => handleMenuAction(event)}
                          />
                        }
                      />
                    </Box>
                  </Box>

                  <Box
                    width={"100%"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    mt={"0.4rem"}
                  >
                    <Box>
                      <Typography fontSize={"0.85rem"}>
                        {appContent?.KEY338}
                      </Typography>
                    </Box>
                    <Box>
                      <FormControlLabel
                        control={
                          <UpdateTaskSwitch
                            name={"reject"}
                            switchLabel=""
                            checked={checkedType === "reject"}
                            handleChange={(event) => handleMenuAction(event)}
                          />
                        }
                      />
                    </Box>
                  </Box>
                  <Box
                    width={"100%"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    mt={"0.4rem"}
                  >
                    <Box>
                      <Typography width={"20rem"} fontSize={"0.85rem"}>
                        {appContent?.KEY339}
                      </Typography>
                    </Box>
                    <Box>
                      <FormControlLabel
                        control={
                          <UpdateTaskSwitch
                            name={"approveAndAskApproval"}
                            switchLabel=""
                            checked={checkedType === "approveAndAskApproval"}
                            handleChange={(event) => handleMenuAction(event)}
                          />
                        }
                      />
                    </Box>
                  </Box>

                  <Box
                    width={"100%"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    mt={"0.4rem"}
                  >
                    <Box>
                      <Typography width={"20rem"} fontSize={"0.85rem"}>
                        {appContent?.KEY365}
                      </Typography>
                    </Box>
                    <Box>
                      <FormControlLabel
                        control={
                          <UpdateTaskSwitch
                            name={"rejectAndAskApproval"}
                            switchLabel=""
                            checked={checkedType === "rejectAndAskApproval"}
                            handleChange={(event) => handleMenuAction(event)}
                          />
                        }
                      />
                    </Box>
                  </Box>
                </>
              )}
              {selectedTaskData?.from?.id === currentUserData?.id && (
                <>
                  {selectApprovalValue?.map((item) => (
                    <Box
                      width={"100%"}
                      display={"flex"}
                      alignItems={"center"}
                      justifyContent={"space-between"}
                      mt={"0.4rem"}
                      key={item?.title}
                    >
                      <Box>
                        <Typography fontSize={"0.85rem"}>
                          {item?.title}
                        </Typography>
                      </Box>
                      <Box>
                        <FormControlLabel
                          control={
                            <UpdateTaskSwitch
                              name={item?.value}
                              switchLabel=""
                              checked={checkedType === item?.value}
                              handleChange={(event) => handleMenuAction(event)}
                            />
                          }
                        />
                      </Box>
                    </Box>
                  ))}
                </>
              )}
            </>
          )}
        </Box>
      </Box>

      {checkedType !== "approveAndAskApproval" && (
        <Box position={"absolute"} bottom={"0"} width={"100%"}>
          {selectedTaskData?.from?.id === currentUserData?.id ? (
            <Box
              display={"flex"}
              paddingLeft={"0.4rem"}
              paddingBottom={"1rem"}
              flexDirection={"column"}
              gap={"0.2rem"}
            >
              <Typography
                fontWeight={600}
                maxWidth={"100%"}
                paddingLeft={"0.4rem"}
                fontSize={fontSizeSchemes.font17}
              >
                {selectedTaskData?.type === MessageType?.Approval
                  ? appContent?.KEY336
                  : appContent?.KEY327}
              </Typography>
            </Box>
          ) : (
            <Box
              display={"flex"}
              paddingLeft={"0.4rem"}
              paddingBottom={"1rem"}
              flexDirection={"column"}
              gap={"0.2rem"}
            >
              {selectedTaskData?.type === MessageType?.Approval ? (
                <>
                  <Typography
                    fontWeight={600}
                    maxWidth={"100%"}
                    paddingLeft={"0.4rem"}
                    fontSize={fontSizeSchemes.font17}
                  >
                    {appContent?.KEY336}
                  </Typography>
                </>
              ) : (
                <>
                  <Typography
                    fontWeight={600}
                    maxWidth={"100%"}
                    paddingLeft={"0.4rem"}
                    fontSize={fontSizeSchemes.font17}
                  >
                    {appContent?.KEY325}
                  </Typography>
                  <Typography
                    fontWeight={400}
                    maxWidth={"100%"}
                    paddingLeft={"0.4rem"}
                    color={colorSchemes.themeRedColor}
                    fontSize={fontSizeSchemes.font12}
                  >
                    {appContent?.KEY326}
                  </Typography>
                </>
              )}
            </Box>
          )}
          <DrawerInput
            handleUpdateTaskApproval={handleUpdateTaskApproval}
            handleClickYouTube={handleClickYouTube}
            setFileAttachment={setFileAttachment}
            handleClickGoogle={handleClickGoogle}
            handleClickCloudStorage={handleClickCloudStorage}
            fileAttachment={fileAttachment}
            actualTimeValue={actualTimeValue}
            attachment={attachment}
            setAttachment={setAttachment}
            taskData={taskData}
            checkedType={checkedType}
            setUpdateTaskApprovalMsg={setUpdateTaskApprovalMsg}
            updateTaskApprovalMsg={updateTaskApprovalMsg}
            selectedRecipients={selectedRecipients}
            setReplyParentMsg={setReplyParentMsg}
            setTaskModalDeatils={setTaskModalDeatils}
            setIsTaskUpdateTypeModalOpen={setIsTaskUpdateTypeModalOpen}
            isTaskUpdateTypeModalOpen={isTaskUpdateTypeModalOpen}
            handleclickAttherate={handleclickAttherate}
            setCheckedType={setCheckedType}
            setSelectRecipientsDrawerOpen={setSelectRecipientsDrawerOpen}
            setStepper={setStepper}
            taskModalDeatils={taskModalDeatils}
            setTaskData={setTaskData}
            setIsTaskTypeModalOpen={setIsTaskTypeModalOpen}
            setSelectedRecipients={setSelectedRecipients}
          />
        </Box>
      )}
    </Box>
  );
};

export default TaskUpdate;
